import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

import { isProd } from '@/global/env';
import { getClient } from '@/lib/restClient';
import { authPagePaths } from '@/router';
import { AuthEnterpriseService } from '@/services/AuthEnterprise';
declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
  }
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const GTMTag = () => {
  const location = useLocation();
  // 認証関連のページ(ログイン・パスワードリセットなど)の場合はGTMスクリプトをセットしない
  if (authPagePaths.includes(location.pathname)) {
    return null;
  }

  new AuthEnterpriseService(getClient())
    .me()
    .then((me) => {
      if (typeof window !== 'undefined') {
        window.dataLayer = window.dataLayer || [];
        const hasGtmCustomVariables = window.dataLayer.some(
          (obj) => !!obj.gtm_custom_variables
        );
        // 未セットの場合のみセットする
        if (!hasGtmCustomVariables) {
          window.dataLayer.push({
            gtm_custom_variables: {
              user_id: me.id,
              user_name: me.name,
              user_group_id: me.enterprise_id,
              user_group_name: me.enterprise_name,
            },
          });
        }
      }
    })
    .catch(() => {
      return null;
    });

  const gtmScript = isProd
    ? `(function(w,d,s,l,i){w[l] = w[l] || [];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl+ '&gtm_auth=N13qHCbKCZQQaq9tPe4HNg&gtm_preview=env-1&gtm_cookies_win=x';f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-P7SJ2CB3');`
    : `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl+ '&gtm_auth=GxM4Kz2VnuI3Bh9mKj3Qng&gtm_preview=env-3&gtm_cookies_win=x';f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-P7SJ2CB3');`;

  const iframeSrc = isProd
    ? 'https://www.googletagmanager.com/ns.html?id=GTM-P7SJ2CB3&gtm_auth=N13qHCbKCZQQaq9tPe4HNg&gtm_preview=env-1&gtm_cookies_win=x'
    : 'https://www.googletagmanager.com/ns.html?id=GTM-P7SJ2CB3&gtm_auth=GxM4Kz2VnuI3Bh9mKj3Qng&gtm_preview=env-3&gtm_cookies_win=x';

  return (
    <>
      <Helmet>
        <script id={isProd ? 'gtm-prd' : 'gtm-stg'}>{gtmScript}</script>
      </Helmet>
      <noscript>
        <iframe
          src={iframeSrc}
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
          title={isProd ? 'gtm-prd' : 'gtm-stg'}
        />
      </noscript>
    </>
  );
};

export default GTMTag;
